import * as React from 'react';

import { FormUpdateProxyProvider } from '../core/context/FormUpdateProxyContext';

interface IControlledForm {
  children: React.ReactNode;
  enableUpdate?: boolean;
  enableOnBlur?: boolean;
  onSubmit?: React.FormEventHandler<HTMLFormElement>;
  onUpdate?: () => (void | null);
  onFieldBlur?: () => (void | null);
  formProps?: React.DetailedHTMLProps<React.FormHTMLAttributes<HTMLFormElement>, HTMLFormElement>;
  style?: React.CSSProperties;
}

function ControlledForm({
  children,
  enableUpdate,
  enableOnBlur,
  onSubmit,
  onUpdate,
  onFieldBlur,
  formProps,
  style,
}: IControlledForm): JSX.Element {
  return (
    <FormUpdateProxyProvider
      requestUpdate={onUpdate || (() => {})}
      onFieldBlur={onFieldBlur || (() => {})}
      allowUpdateOnFieldBlur={enableOnBlur}
      allowUpdate={enableUpdate ?? false}
    >
      <form onSubmit={onSubmit} {...formProps} style={style}>
        {children}
      </form>
    </FormUpdateProxyProvider>
  );
}

export default ControlledForm;
